import React from "react";
import Pagination from "../../helpers/Pagination";
import { FaFilter } from "react-icons/fa";

const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatCurrency = (value = 0) => {
  return `₹${Number(value).toLocaleString("en-IN")}`;
};

export default function StageClientTable({
  data = [],
  pagination,
  onPageChange,
  onItemsPerPageChange,
  searchTerm,
  setSearchTerm,
  onFilterClick,
  onExportExcel,
  onExportPDF,
  activeFiltersCount
}) {
  return (
    <div className="bg-white overflow-hidden">
      {/* Header */}

    <div className="px-5 py-4 bg-white flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h2 className="text-lg font-semibold">Client Stage List</h2>
        <p className="text-sm text-gray-500">
          Current pipeline snapshot
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {/* <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search Client..."
          className="px-3 py-2 border rounded-lg w-64"
        /> */}

        <button
          onClick={onFilterClick}
          className="
            relative
            flex items-center gap-2
            px-3 py-3            
            rounded-lg
          bg-red-100 
          "
        >
          <FaFilter className="text-sm" />
          {/* <span>Filter</span> */}

          {activeFiltersCount > 0 && (
            <span
              className="
                absolute
                -top-2
                -right-2
                bg-red-600
                text-white
                text-xs
                w-5
                h-5
                rounded-full
                flex
                items-center
                justify-center
              "
            >
              {activeFiltersCount}
            </span>
          )}
        </button>

        <button
          onClick={onExportExcel}
          className="px-4 py-2 bg-green-600 text-white rounded-lg"
        >
          Excel
        </button>

        <button
          onClick={onExportPDF}
          className="px-4 py-2 bg-red-600 text-white rounded-lg"
        >
          PDF
        </button>
      </div>
    </div>

      {/* Table */}

      <div className="overflow-x-auto rounded-md">
        <table className="min-w-full bg-white border-separate border-spacing-y-2 px-2">
          <thead className="text-sm text-gray-600">
            <tr className="text-center rounded-lg shadow-sm bg-red-100">
              <th className="py-4 px-4 rounded-l-lg font-semibold">
                Client
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold">
                Contact
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold">
                Division
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold">
                Owner
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold">
                Stage
              </th>

              <th className="px-4 py-3 text-right text-sm font-semibold">
                Estimated
              </th>

              <th className="px-4 py-3 text-right text-sm font-semibold">
                Expected
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold">
                Closing
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold">
                Changed
              </th>

              <th className="py-4 px-4 rounded-r-lg font-semibold">
                Status
              </th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((row) => (
                <tr key={row._id} className="bg-gray-50 hover:bg-gray-100 text-sm rounded-lg shadow-sm text-center">
                  {/* CLIENT */}

                  <td className="py-3 px-4 font-medium text-gray-700 rounded-l-lg">
                    <div>
                      <p className="font-semibold text-gray-900">
                        {row.clientName}
                      </p>

                      <p className="text-xs text-gray-500">{row.clientId}</p>

                    </div>
                  </td>
                  <td className="py-3 px-4 font-medium text-gray-700">
                    <div>
                      <p className="text-xs text-gray-500 whitespace-nowrap">{row.contactName}</p>

                      <p className="text-xs text-gray-500">
                        {row.contactPhone}
                      </p>
                    </div>
                  </td>
                  {/* DIVISION */}

                  <td className="px-4 py-4">
                    <span className="font-medium whitespace-nowrap">{row.divisionId?.name}</span>
                  </td>

                  {/* OWNER */}

                  <td className="px-4 py-4 whitespace-nowrap">
                    {row.userId
                      ? `${row.userId.firstName} ${row.userId.lastName}`
                      : "-"}
                  </td>

                  {/* STAGE */}

                  <td className="px-4 py-4">
                    <div className="flex flex-col gap-1">
                      <span
                        className="
                        px-3
                        py-1
                        rounded-full
                        text-white
                        text-xs
                        font-medium
                        inline-block
                        w-fit
                      "
                        style={{
                          backgroundColor: row.stageId?.color,
                        }}
                      >
                        {row.stageId?.stageName}
                      </span>

                      <span className="text-xs text-gray-500">
                        Probability : {row.stageId?.probability}%
                      </span>
                    </div>
                  </td>

                  {/* ESTIMATED */}

                  <td className="px-4 py-4 text-right font-medium">
                    {formatCurrency(row.estimatedValue)}
                  </td>

                  {/* EXPECTED */}

                  <td className="px-4 py-4 text-right font-medium">
                    {formatCurrency(row.expectedValue)}
                  </td>

                  {/* CLOSING */}

                  <td className="px-4 py-4 text-center whitespace-nowrap">
                    {formatDate(row.expectedClosingDate)}
                  </td>

                  {/* CHANGED */}

                  <td className="px-4 py-4 text-center whitespace-nowrap">
                    {formatDate(row.stageChangedAt)}
                  </td>

                  {/* STATUS */}

                  <td className="py-3 px-4 text-gray-500 rounded-r-lg">
                    <span
                      className={`
                        px-3 py-1 rounded-full text-xs font-medium
                        ${
                          row.stageId?.type === "won"
                            ? "bg-green-100 text-green-700"
                            : row.stageId?.type === "lost"
                              ? "bg-red-100 text-red-700"
                              : "bg-blue-100 text-blue-700"
                        }
                      `}
                    >
                      {row.stageId?.type}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="py-10 text-center text-gray-500">
                  No clients found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}

      {pagination?.total > 0 && (
        <div className="p-4">
          <Pagination
            totalItems={pagination.total}
            itemsPerPage={pagination.limit}
            currentPage={pagination.page}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        </div>
      )}
    </div>
  );
}
